import { REPORT_PAGE } from "routes/route.constant";
import Report from "./Report";

const route = {
  path: REPORT_PAGE,
  element: Report,
};

export default route;
